/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:05
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-18 11:46:41
 */

import { unwrapResult } from '@reduxjs/toolkit'
import { Col } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import styles from './AnnualCapitalFund.module.css'
import { Query } from './Query'
import { RootDispatch } from '../../../../app/store'
import { getDateRange, DateRangeType } from '../../../../compnents/form/DateSelect'
import { EditableList } from '../../../../compnents/list/EditableList'
import { DateTimeFormat } from '../../../../models/datetime'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { ScanRateColumn, UploadRateColumns } from './column'
import { getTraceCodeScanRateListAsync, getTraceCodeUploadRateListAsync } from './TraceCodeScanRateSlice'
import { NoTraceCodeRecordModal } from './NoTraceCodeRecordModal'

interface TraceCodeScanRateProps {
  selectedTab?: any
}

const TraceCodeScanRate = ({ selectedTab }: TraceCodeScanRateProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({})

  const [page, setPage] = useState<any>()

  const [pages, setPages] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false)

  useEffect(() => {
    if (selectedTab == '1') {
      const time = {
        startTime: params?.startTime
          ? moment(params?.startTime).format(DateTimeFormat)
          : moment(timeHead).format(DateTimeFormat),
        endTime: params?.endTime
          ? moment(params?.endTime).endOf('day').format(DateTimeFormat)
          : moment(timeTail).format(DateTimeFormat),
      }
      setPageLoading(true)
      getScanRatePage(time)
    }
  }, [selectedTab, params])

  const getScanRatePage = (time: any) => {
    dispatch(getTraceCodeScanRateListAsync({ ...params, ...time }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage([res.acquisitionRate])
        setPages([res.uploadRateData])
        setPageLoading(false)
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  return (
    <>
      <Col
        style={{
          backgroundColor: theme.pn,
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 10px)',
          overflow: 'hidden',
        }}
      >
        <Query
          onValueChange={(v: any) => {
            const paramData = {
              ...params,
              ...v,

            }
            setParams({
              ...paramData,
            })
          }}
          loading={pageLoading}
        />
        <div style={{ flex: 1 }}>
          <div style={{ margin: '10px 0' }}>药品销售扫码率 （不包含拆零药品）</div>
          <EditableList
            rowKey={(v, i) => `${i}`}
            loading={pageLoading}
            pagination={false}
            page={{
              current: 1,
              size: 10,
              total: 0,
              items: page,
            }}
            columns={ScanRateColumn((action, t) => {
              if (action == 'lookDetail') {
                setIsModalVisible(true)
              }
            })}
            onChangePage={(current, size) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
          />
          <div style={{ margin: '10px 0' }}>药品销售上传率</div>
          <EditableList
            rowKey={(v, i) => `${i}`}
            loading={pageLoading}
            pagination={false}
            page={{
              current: 1,
              size: 10,
              total: 0,
              items: pages,
            }}
            columns={UploadRateColumns(params)}
            onChangePage={(current, size) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
          />
        </div>
      </Col>
      <NoTraceCodeRecordModal
        params={{
          ...params, 
          startTime: params?.startTime
            ? moment(params?.startTime).format(DateTimeFormat)
            : moment(timeHead).format(DateTimeFormat),
          endTime: params?.endTime
            ? moment(params?.endTime).endOf('day').format(DateTimeFormat)
            : moment(timeTail).format(DateTimeFormat),
        }}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
        }}
        onOk={() => {
          setIsModalVisible(false)
        }}
      ></NoTraceCodeRecordModal>
    </>
  )
}

export const TraceCodeScanRates = forwardRef(TraceCodeScanRate)
